module.exports = "<!-- main  start -->\r\n<div id=\"main\">\r\n  <div class=\"error-wrap\">\r\n    <div class=\"error-holder\">\r\n      <strong class=\"error-number\">404</strong>\r\n      <span class=\"error-text\">Страница не найдена</span>\r\n      <a class=\"error-link\" href=\"#\" routerLink=\"/main\">Вернуться на главную</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- main  end -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/not-found.component.html
// module id = ./src/app/components/common/not-found.component.html
// module chunks = main